module.exports = __webpack_public_path__ + "img/7-3.2682fe0b.png";